import { defineAsyncComponent } from 'vue'
import { useGoogleDriveStore } from '~~/stores/google-drive'

export default defineNuxtPlugin(() => {
    const { register } = usePickerRegistry()
    const driveStore = useGoogleDriveStore()

    register({
        name: 'google_folder',
        editComponent: defineAsyncComponent(
            () => import('../components/picker/GoogleFolderPickerEdit.vue'),
        ),
        resolveLabel: (folderId, ctx) => driveStore.resolveFolderPath(folderId, ctx.identityId),
    })

    register({
        name: 'aws_region',
        editComponent: defineAsyncComponent(
            () => import('../components/picker/AwsRegionPickerEdit.vue'),
        ),
        resolveLabel: (value) => Promise.resolve(value),
    })

    register({
        name: 'cloudflare_zone',
        editComponent: defineAsyncComponent(
            () => import('../components/picker/CloudflareZonePickerEdit.vue'),
        ),
        resolveLabel: (value) => Promise.resolve(value),
    })
})
